module.exports = __webpack_public_path__ + "img/fb4b358.svg";